<div [ngClass]="'idp-image-with-label ' + size">
  <div
    *ngIf="image.src"
    [class]="'idp-image-section' + ' image-size-' + imageSize"
  >
    <idp-image [content]="image"></idp-image>
  </div>
  <div *ngIf="label" [innerHTML]="label" data-label-section="true"></div>
</div>
